{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Tüm Seçenekleri Gör",
  "Spoiler_Reveal_Tooltip": "Açmak için tıklayın",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "Bunu tweetle",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "Öge daraltıldı",
  "Spoiler_Reveal_Video_CTA": "Videoyu Göster",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "Görüntüyü Genişlet",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "Tüm Sonuçları Göster",
  "Spoiler_Reveal_Image_Placeholder": "Bu görüntü, spoiler içerir",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Arama kaydırıcısı",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "Birden fazla cevap için oy verebilirsiniz.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Daha fazla ses kontrolü göster",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Failed to load service",
  "Fullscreen_Close_Button_AriaLabel": "Kapat",
  "VerticalEmbed_Event_Fetch_Error_Title": "Failed to load event",
  "UploadFile_Viewer_Loader": "{{fileType}} yükleniyor",
  "Polls_Plugin_User_Avatar_Alt": "Kullanıcı avatarı",
  "Preview_ReadMore_Label": "Daha Fazla Bilgi",
  "Spoiler_Insert_Tooltip": "Spoiler",
  "VerticalEmbed_Product_Fetch_Error_Title": "Failed to load product",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Ses",
  "Spoiler_Reveal_Gallery_Placeholder": "Bu galeri, spoiler içerir",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "Yer Ayırt",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Sesi Aç",
  "Spoiler_Reveal_Gallery_CTA": "Galeriyi Göster",
  "Poll_Viewer_ShowLess_CTA": "Daha Az Göster",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Sessize Al",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} anonim",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Takip Et",
  "VerticalEmbed_Products_Button": "Satın Al",
  "Poll_Viewer_Toast_Error_ServerDown": "Sunucuya bağlanılamadı. Daha sonra tekrar deneyin.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} kişi bu cevap için oy verdi",
  "Poll_Viewer_VoteCount": "{{number}} oy",
  "VerticalEmbed_Events_Button": "Hemen Kaydol",
  "Spoiler_Reveal_Image_CTA": "Görüntüyü Göster",
  "Poll_Viewer_Toast_Error_Connection": "İnternet yok. Bağlantınızı kontrol edin.",
  "Poll_Viewer_Visibility_Owner_Footer": "Sonuçları sadece siz görebilirsiniz.",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} kişi bu yanıt için oy verdi",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "Öge genişletildi",
  "Audio_Plugin_Cover_Alt": "Ses dosyası kapağı",
  "Spoiler_Reveal_Video_Placeholder": "Bu video, spoiler içerir",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Unable to load product information.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "Tamamını görüntüle",
  "UploadFile_Viewer_Download": "{{fileType}} dosyasını indir",
  "VerticalEmbed_Units_Hour": "{{hours}} sa.",
  "VerticalEmbed_Units_Minute": "{{minutes}} dk.",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Unable to load event information.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Unable to load service information.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
